import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { isQuickStartEligible } from '../utils/isQuickStartEligible'

export const useIsQuickStartEligible = (): boolean => {
  const { organization } = useUserOrganization()

  return useMemo(() => isQuickStartEligible({ organization }), [organization])
}
